import { Injectable } from '@angular/core';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { CoverpathControllerInterface } from '../../../../../coverpath-common/angular/interfaces/controller/CoverpathControllerInterface';
import { AgentControllerInterface } from '../../types/Types';

@Injectable({
  providedIn: 'root',
})
export class AgentAmorphicService extends AmorphicService {
  controller: CoverpathControllerInterface & AgentControllerInterface;
}
